import { AxiosResponse } from "axios"
import {
    ICreateGroup,
    IGetGroupsResponse,
    IGroup,
    IGroupAccrualRequest,
    IUpdateGroup,
    IVisibilityAcl,
    ISetVisibilityAclRequest,
    IVisibilityAclTableResponse,
    TargetType,
    GroupAccessSource,
} from "./types"
import { apiInstance } from "../base"
import { RoleType } from "../users"

export const getGroups = (role: RoleType): Promise<AxiosResponse<IGetGroupsResponse>> => {
    return apiInstance.handler.get<IGetGroupsResponse>(`/groups`, {
        params: {
            with_include: true,
            role_id: role,
            all: true
        }
    })
}

export const deleteGroup = (id: string): Promise<AxiosResponse<IGroup>> => {
    return apiInstance.handler.delete(`/groups/${id}`)
}
export const createGroup = (data: ICreateGroup): Promise<AxiosResponse<IGroup>> => {
    return apiInstance.handler.post(`/groups`, data)
}
export const updateGroup = (data: IUpdateGroup): Promise<AxiosResponse<IGroup>> => {
    return apiInstance.handler.put(`/groups/${data.group_id}`, data)
}
export const groupAccrual = (id: string, data: IGroupAccrualRequest): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post(`/groups/${id}/accrual`, data)
}
export const addUser = (groupId: string, userId: string) => {
    return apiInstance.handler.post(`/groups/${groupId}/add/${userId}`)
}
export const removeUser = (groupId: string, userId: string) => {
    return apiInstance.handler.post(`/groups/${groupId}/remove/${userId}`)
}

export const setVisibilityAcl = (data: ISetVisibilityAclRequest): Promise<AxiosResponse<IVisibilityAcl>> => {
    return apiInstance.handler.post<IVisibilityAcl>(`/visibility-acl`, data)
}

export interface IGetAclListParams {
    target_type?: TargetType
    target_id?: string
}

export interface IGetVisibilityAclTableParams {
    group_id?: string
    viewer_target_type?: TargetType
    viewer_target_id?: string
    group_access_source?: GroupAccessSource
}

export const getAclList = (params?: IGetAclListParams): Promise<AxiosResponse<IVisibilityAcl[]>> => {
    return apiInstance.handler.get<IVisibilityAcl[]>(`/visibility-acl/list`, {
        params
    })
}

export const deleteAcl = (acl_id: string): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.delete<void>(`/visibility-acl/${acl_id}`)
}

export const getVisibilityAclTable = (params?: IGetVisibilityAclTableParams): Promise<AxiosResponse<IVisibilityAclTableResponse>> => {
    return apiInstance.handler.get<IVisibilityAclTableResponse>(`/visibility-acl/table`, {
        params,
    })
}